import React from 'react';
import Image from '../../../img/MainWebsite/VenuesPage.png';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

function ForVenues() {

  let navigate = useNavigate();

  return (
    <main >
      <Header />
      <div className={'mainContent  whiteFont'}>
        <div className={'column'}>
          <h2 className={'left blue'}>A BETTER WAY TO PRESENT THE EVENT EXPERIENCE  </h2>
          <h5 className={'left'}>Designed for Venues:  </h5>
          <ul className={"two-columns"}>
            <li className={'blue left'}><h5>Accessible on guests’ own phones or tablets </h5></li>
            <li className={'blue left'}><h5>Presents concessions, merchandise, upgrades, and services clearly </h5></li>
            <li className={'blue left'}><h5>Supports guest navigation and decision-making </h5></li>
            <li className={'blue left'}><h5>Reduces repetitive questions during peak traffic  </h5></li>
            <li className={'blue left'}><h5>Generate an additional revenue stream  </h5></li>
            <li className={'blue left'}><h5>Exclusively branded for your venue  </h5></li>
            <li className={'blue left'}><h5>No investment, no setup fees, no hardware, no training, no downloads, and no financial risk </h5></li>
          </ul>

          <h5 className={'left'}>Today’s event guests value clarity, convenience, and a well-orchestrated experience from arrival through exit.
            Delivering that level of service at scale requires tools that enhance communication and presentation—without
            interrupting the live event. </h5>
          <h5 className={'left'}>Vizo Menu provides a supplemental digital presentation layer, accessible on guests’ own phones or tablets, that
            helps venues present food and beverage options, merchandise, premium upgrades, wayfinding, and event
            services in one place. Whether guests are in their seats, at a concession stand, or moving through the concourse,
            they can easily access relevant information at their own pace. </h5>
          <h5 className={'left'}>Designed for high-volume, live environments, Vizo Menu supports guest understanding and reduces repetitive
            questions during peak moments—helping staff focus on service while maintaining smooth flow throughout the
            venue. </h5>
          <h5 className={'left'}>Venues can strengthen engagement, support efficient operations, and
            help generate an additional revenue stream through discreet sponsorships that don’t clutter the menu or detract
            from the event experience. </h5>
          <h5 className={'left'}>Vizo Menu integrates unobtrusively into venue operations and is exclusively branded for your venue, ensuring
            guests engage only with your offerings and your brand—not a third-party platform. </h5>
          <h5 className={'left'}>Best of all, Vizo Menu is provided at no investment. Our business model enables venues to elevate presentation,
            consistency, and sponsorship value with no setup fees, no hardware, no training, no downloads, and no financial
            risk. </h5>
          <h5 className={'blue left italic'}>A thoughtful enhancement—designed to support great events without competing with them. </h5>
        </div>
        <div className={'column'}>
          <img src={Image} className={'page-image image-border'} alt="Image 2" />
          <button className={' button-spacing chrome-background blue-link'} onClick={() => { navigate("/Contact-Us") }}>
            CONTACT US TO SCHEDULE A DEMO
          </button>
        </div>
      </div>
      <Footer />
    </main>
  );
}

export default ForVenues;